/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdTeacherDataQueryResponse,
  GetApiV1PersonIdTeacherDataPathParams,
  GetApiV1PersonIdTeacherData401,
  GetApiV1PersonIdTeacherData404,
  GetApiV1PersonIdTeacherData500,
} from "../../types/personTeacherController/GetApiV1PersonIdTeacherData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdTeacherData } from "../../clients/personTeacherController/getApiV1PersonIdTeacherData.ts";

export const getApiV1PersonIdTeacherDataQueryKey = (
  id: GetApiV1PersonIdTeacherDataPathParams["id"],
) => [{ url: "/api/v1/person/:id/teacher-data", params: { id: id } }] as const;

export type GetApiV1PersonIdTeacherDataQueryKey = ReturnType<
  typeof getApiV1PersonIdTeacherDataQueryKey
>;

export function getApiV1PersonIdTeacherDataQueryOptions(
  id: GetApiV1PersonIdTeacherDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdTeacherDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdTeacherDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdTeacherData401
      | GetApiV1PersonIdTeacherData404
      | GetApiV1PersonIdTeacherData500
    >,
    GetApiV1PersonIdTeacherDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdTeacherData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados da aba Teacher (TeachingStaff + campos de Person: BusinessSector, OtherBusinessSector, AcademicInstitution). O thumbnail é gerenciado pelos endpoints /teacher-thumbnail. **(Requer Authorization para autenticação)**
 * @summary Obter dados de docente (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/teacher-data}
 */
export function useGetApiV1PersonIdTeacherData<
  TData = GetApiV1PersonIdTeacherDataQueryResponse,
  TQueryData = GetApiV1PersonIdTeacherDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdTeacherDataQueryKey,
>(
  id: GetApiV1PersonIdTeacherDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdTeacherDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdTeacherData401
          | GetApiV1PersonIdTeacherData404
          | GetApiV1PersonIdTeacherData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdTeacherDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdTeacherDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdTeacherData401
      | GetApiV1PersonIdTeacherData404
      | GetApiV1PersonIdTeacherData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
